import { render, staticRenderFns } from "./CustomerNumber.vue?vue&type=template&id=e38f45d4&scoped=true&"
import script from "./CustomerNumber.vue?vue&type=script&lang=js&"
export * from "./CustomerNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38f45d4",
  null
  
)

export default component.exports